var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMagicGenerate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1D1D1D",
  d: "m5.714 6.469 1.714.96-.96-1.715L7.429 4l-1.714.96L4 4l.96 1.714L4 7.43zM14.857 6.469l1.714.96-.96-1.715.96-1.714-1.714.96L13.143 4l.96 1.714-.96 1.715zM5.714 12.96 4 12l.96 1.715L4 15.429l1.714-.96 1.714.96-.96-1.714.96-1.714zM19.413 16.587 9.714 6.886 6.886 9.715l9.699 9.7L18 18zm-8.59-4.552L8.537 9.749 9.75 8.537l2.285 2.286z"
})));
export default SvgMagicGenerate;